export default {
  settings: {
    title: 'Impostazioni',
    account: 'Account',
    appSettings: 'Impostazioni App',
    dataPrivacy: 'Dati e Privacy',
    emptyProfile: 'Nessun dato profilo disponibile. Completa l\'onboarding per popolare il tuo profilo.',
    emptyState: {
      title: 'Non abbiamo rilevato dati profilo salvati.',
      body: 'Esegui l\'onboarding cosi la pianificazione delle quest ha tutti gli input necessari.',
    },
    appLanguage: {
      title: 'Lingua App',
      description: "Scegli la lingua predefinita dell'app e dell'AI.",
      save: 'Salva Lingua',
      saving: 'Salvataggio...',
      updated: 'Preferenza lingua aggiornata.',
      error: 'Impossibile aggiornare la preferenza lingua.',
    },
    metricUnits: 'Metrico (kg, km)',
    managePlan: 'Gestisci piano',
    levelBadge: 'Livello {level}',
    profileSection: 'Profilo',
    trainingSection: 'Allenamento',
    nutritionSection: 'Nutrizione',
    equipmentSection: 'Attrezzatura',
    bodyCompositionSection: 'Composizione corporea',
    healthNutritionSection: 'Salute e nutrizione',
    profileSnapshot: 'Riepilogo profilo',
    preferencesSection: 'Preferenze',
    fullExtractedProfile: 'Profilo estratto completo',
    completeOnboardingFirst: 'Completa prima l\'onboarding, poi torna qui per modificare il profilo salvato.',
    profileUpdatedNoQuestChange: 'Profilo aggiornato. Le quest restano invariate.',
    labels: {
      fullName: 'Nome completo',
      age: 'Eta',
      gender: 'Genere',
      location: 'Posizione',
      height: 'Altezza',
      weight: 'Peso',
      exerciseFamiliarity: 'Familiarita con l\'esercizio',
      weeklyActivity: 'Attivita settimanale',
      sessionsPerWeek: 'Sessioni a settimana',
      preferredWorkoutDays: 'Giorni preferiti per allenarti',
      fitnessGoals: 'Obiettivi fitness',
      workoutStyles: 'Stili di allenamento',
      preferredUnits: 'Unita preferite',
      availableEquipment: 'Attrezzatura disponibile',
      notes: 'Note',
      medicalConditions: 'Condizioni mediche, infortuni o dolore',
      dietaryPreferences: 'Preferenze alimentari',
      allergies: 'Allergie',
    },
    measurements: {
      neck: 'Collo',
      chest: 'Petto',
      waist: 'Vita',
      hips: 'Fianchi',
      thigh: 'Coscia',
    },
    training: {
      sessionsPerWeekValue: '{count} sessioni / settimana',
    },
    nutrition: {
      allergiesValue: 'Allergie: {value}',
    },
    actions: {
      rescheduleTitle: 'Ripianifica quest',
      rescheduleDescription: 'Aggiorna gli input del profilo e avvia un nuovo piano quest quando vuoi.',
      editProfile: 'Modifica profilo',
      editingProfile: 'Modifica profilo in corso',
      editProfileDescription: 'Aggiorna dettagli e preferenze senza rigenerare automaticamente le quest.',
    },
    push: {
      title: 'Notifiche push',
      needsSetup: 'Le notifiche sono state richieste, ma questo iPhone deve ancora sincronizzare un token push valido.',
      permissionDenied: 'Le notifiche sono bloccate nelle Impostazioni di iPhone.',
      enabledDescription: 'Le notifiche di quest, streak, classifica e duel sono attive su questo iPhone.',
      disabledDescription: 'Le notifiche di quest, streak, classifica e duel sono disattivate su questo iPhone.',
      iosOnly: 'Le notifiche push sono disponibili solo nell\'app iOS.',
      enabledFeedback: 'Notifiche push attivate.',
      disabledFeedback: 'Notifiche push disattivate.',
      disabledInSettings: 'Le notifiche push sono state disattivate nelle Impostazioni di iPhone.',
      deniedHelp: 'Le notifiche sono disattivate nelle Impostazioni di iPhone. Attivale li e riprova.',
      updateFailed: 'Impossibile aggiornare le notifiche push.',
      sendTest: 'Invia notifica di test',
      sendingTest: 'Invio notifica di test...',
      testDescription: 'Invia una notifica una tantum a questo iPhone e mostra lo stato corrente di consegna Expo.',
      lastTest: 'Ultimo risultato del test',
      ticketId: 'ID ticket',
      providerError: 'Errore provider',
      testDelivered: 'Notifica di test consegnata con successo.',
      testPending: 'Notifica di test accettata. La conferma della receipt e ancora in attesa.',
      testFailed: 'Impossibile inviare la notifica push di test.',
      testStatusDelivered: 'Consegnata',
      testStatusPending: 'In attesa',
      testStatusAccepted: 'Accettata',
      testStatusNotReady: 'Non pronta',
      testStatusError: 'Errore',
      openSettings: 'Apri Impostazioni iPhone',
    },
    healthKit: {
      title: 'Verifica HealthKit',
      description: 'Gestisci l\'accesso iOS a HealthKit per la verifica di passi, sonno e calorie attive.',
    },
    guideRestore: {
      title: 'Ripristina guida funzioni',
      description: 'Riapri la guida dashboard e i suggerimenti prodotto.',
      successTitle: 'Successo',
      successBody: 'Guida funzioni ripristinata. Controlla la Dashboard.',
    },
    aboutForza: {
      title: 'About Forza',
      description: 'Apri la guida pubblica, la panoramica prodotto e le informazioni di lancio.',
    },
    healthSources: {
      title: 'Fonti salute',
      description: 'Scopri da dove arrivano i consigli salute e i default di pianificazione di Forza, con link alle fonti originali.',
    },
    support: {
      title: 'Supporto',
      description: 'Ricevi aiuto e contattaci direttamente.',
    },
    logout: {
      title: 'Logout',
      description: 'Esci dal tuo account su questo dispositivo.',
    },
    download: {
      title: 'Scarica i miei dati',
      description: 'Esporta profilo, impostazioni e cronologia quest.',
      started: 'Download dati avviato.',
      failed: 'Impossibile scaricare i dati.',
    },
    delete: {
      title: 'Elimina account',
      description: 'Elimina definitivamente il tuo account e anonimizza tutti i dati collegati.',
      footnote: 'Eliminare l\'account anonimizza il profilo e rimuove gli snapshot HealthKit. I log audit restano anonimizzati fino a 12 mesi.',
      modalTitle: 'Elimina il tuo account',
      modalBody: 'Questo eliminera definitivamente il tuo account. Email, username e dati profilo verranno anonimizzati. Gli snapshot HealthKit vengono rimossi. I log anonimizzati restano fino a 12 mesi per audit e prevenzione frodi.',
      confirmLabel: 'Digita DELETE per confermare',
      confirmPlaceholder: 'DELETE',
      cancel: 'Annulla',
      confirm: 'Elimina account',
      deleting: 'Eliminazione...',
      typeDelete: 'Digita DELETE per confermare l\'eliminazione account.',
      failed: 'Impossibile eliminare l\'account. Riprova.',
    },
    plan: {
      limitReached: 'Limite rigenerazione quest raggiunto.',
      alreadyRunning: 'La rigenerazione del piano quest e gia in corso.',
      failedDefault: 'La rigenerazione delle quest non e stata completata. Riprova quando vuoi.',
      inProgressTitle: 'La rigenerazione del piano quest e in corso.',
      triggeredBy: 'Avviato da {source}',
      triggeredBySystem: 'Avviato dal sistema',
      startedAt: 'Iniziato alle {time}',
      autoUpdate: 'La dashboard si aggiornera automaticamente.',
      failedTitle: 'Rigenerazione piano quest non riuscita.',
      lastAttempt: 'Ultimo tentativo terminato alle {time}. Riprova quando vuoi.',
      rescheduling: 'Ripianificazione...',
      rescheduleFailed: 'Ripianificazione fallita',
      rescheduleComplete: 'Ripianificazione completata',
    },
    assessment: {
      title: 'Fitness Assessment',
      completed: 'Completato',
      skipped: 'Saltato',
      available: 'Disponibile',
      description: 'Completa questa baseline auto-riportata una sola volta per ricalibrare la difficolta delle quest future. Se il tuo livello attuale e piu alto, il livello guadagnato viene preservato.',
      close: 'Chiudi assessment',
      start: 'Avvia assessment',
      assignedLevel: 'Livello assegnato',
      submitted: 'Inviato',
      qualityHeadline: 'Scegli la qualita del movimento controllato, non i numeri massimi.',
      qualityBody: 'Seleziona la variante piu difficile che puoi eseguire in sicurezza e inserisci il risultato. L invio e una sola volta.',
      resultPlaceholder: 'Risultato',
      safetyNote: 'Questo assessment e auto-riportato e non sostituisce l\'idoneita medica. Fermati se qualcosa non va.',
      submit: 'Invia assessment una tantum',
      submitting: 'Invio assessment...',
      submittedFeedback: 'Fitness assessment inviato.',
      submitFailed: 'Impossibile inviare il fitness assessment.',
      raiseLevelConfirm: 'Inviare questo assessment una tantum alzera la tua baseline iniziale e rigenerera le quest future incomplete. Continuare?',
    },
    errors: {
      save: 'Si e verificato un errore durante il salvataggio.',
    },
  },
  appShell: {
    loading: 'Caricamento...',
  },
  playerStats: {
    locked: 'Bloccato',
    syncedAt: 'Sincronizzato alle {time}',
    greeting: 'Ciao {name}',
    timeLeft: '{time} rimaste',
    nutritionToday: 'Nutrizione di oggi',
    caloriesBurned: 'Calorie bruciate',
    notSynced: 'Non sincronizzato',
    workoutVerified: 'Workout verificato',
    workoutInProgress: 'Workout in corso',
    activeEnergyToday: 'Energia attiva di oggi',
    healthKitStepsTitle: 'Obiettivo 10.000 passi',
    healthKitSleepTitle: 'Obiettivo 7 ore di sonno',
    healthKitPrompt: 'Attiva la verifica HealthKit nelle Impostazioni su iOS per monitorare i passi, il sonno e le calorie attive di oggi.',
    healthKitSyncHint: 'La sincronizzazione avviene all\'apertura dell\'app e quando torna in primo piano, al massimo ogni 15 minuti.',
    healthKitEnableStatus: 'Attiva la verifica HealthKit nelle Impostazioni su iPhone',
    healthKitCompleted: 'Completato',
    healthKitWaiting: 'In attesa della sincronizzazione HealthKit',
    healthKitInProgress: 'In corso',
  },
  coachLocked: {
    title: 'AI Coach',
    subtitle: 'Funzione inclusa solo in Ultra',
    upgrade: 'Passa a Ultra',
  },
  auth: {
    loginTitle: 'Bentornato',
    loginSubtitle: 'Riprendi da dove avevi lasciato.',
    email: 'Indirizzo email',
    password: 'Password',
    signIn: 'Accedi',
    continueWith: 'Oppure continua con',
    signInWithApple: 'Accedi con Apple',
    signInWithGoogle: 'Accedi con Google',
    createAccount: 'Nuovo qui? Crea il tuo account',
    registerTitle: 'Crea il tuo account',
    registerSubtitle: 'Imposta il profilo e sblocca il tuo primo piano.',
    username: 'Username',
    confirmPassword: 'Conferma password',
    register: 'Crea account',
    signUpWithApple: 'Registrati con Apple',
    signUpWithGoogle: 'Registrati con Google',
    alreadyHaveAccount: 'Hai gia un account? Accedi',
    inviteOnlyTitle: "L'accesso anticipato e ancora selezionato",
    inviteOnlySubtitle: "Stiamo aprendo Forza gradualmente per mantenere alta la qualita dell'esperienza e del coaching.",
    needAccess: 'Ti serve accesso? Richiedi early access',
    alreadyApproved: 'Gia approvato?',
    approvedEmailPrompt: "Usa l'email che ha ricevuto l'approvazione per sbloccare la registrazione.",
    approvedEmailPlaceholder: 'Email approvata',
    checking: 'Controllo...',
    continue: 'Continua',
    unlockReady: 'Registrazione pronta allo sblocco',
    unlockReadyDescription: 'La tua email approvata sta per aprire la registrazione. Completa subito il signup per evitare che lo sblocco scada.',
    registrationUnlocked: 'Registrazione sbloccata',
    registrationUnlockedDescription: "Questa approvazione apre la registrazione per poco tempo. Completare la creazione dell'account la consumera in modo permanente.",
    approvedEmail: 'Email approvata: {email}',
    termsAgreement: 'Ho letto e accetto i Termini di Servizio e la Privacy Policy.',
    ageConfirm: 'Confermo di avere almeno 16 anni.',
    aiConsent: 'Acconsento al trattamento dati AI richiesto.',
    viewDetails: 'Vedi dettagli',
    consentTag: 'Dati e Privacy',
    consentTitle: 'Trattamento dati AI',
    consentProcessed: 'Dati che possono essere trattati',
    consentProviders: 'Provider AI e vocali',
    consentInfrastructure: 'Provider infrastrutturali',
    consentWhenSent: 'Quando i dati vengono inviati',
    consentAgree: 'Accetta e continua',
    consentDecline: 'Rifiuta',
    consentClose: 'Chiudi i dettagli sul trattamento dati AI',
    consentIntro:
      'Forza usa provider AI e vocali affidabili per generare quest personalizzate, accompagnarti con il coaching, verificare i completamenti, controllare la tecnica e alimentare le funzioni AI collegate.',
    consentProcessedItems: {
      profile: 'Obiettivi fitness, preferenze, contesto profilo e risposte date in onboarding.',
      quests: 'Piani quest, attivita sulle quest, stato di completamento e contesto di verifica.',
      text: "Testi che invii alle funzioni alimentate dall'AI.",
      voice: 'Registrazioni vocali e trascrizioni inviate a Voice Coach o alla verifica vocale.',
      photos: 'Foto inviate per verificare meal o altre quest.',
      exercise: 'Frame degli esercizi inviati per il controllo della tecnica.',
      diagnostics: 'Contesto app, dispositivo e diagnostica necessario per far funzionare, proteggere e monitorare queste funzioni.',
    },
    consentProvidersBody:
      'Forza puo usare Google, Groq, OpenRouter, DeepSeek, OpenAI e provider locali o on-device quando disponibili.',
    consentInfrastructureBody:
      'I dati collegati possono essere trattati anche da provider usati per hosting, storage, distribuzione media, monitoraggio, abbonamenti, consenso pubblicitario, attribuzione dei reward e sicurezza, inclusi Render, MongoDB Atlas, Cloudflare R2, ImageKit, Better Stack, Apple, RevenueCat e Google AdMob quando rilevante.',
    consentWhenSentItems: {
      onboarding: 'Durante onboarding e generazione delle quest.',
      coach: 'Quando usi AI Coach o Voice Coach.',
      verification: 'Quando invii note vocali, foto o frame degli esercizi per verifica o form check.',
      planning: 'Quando le funzioni AI hanno bisogno del contesto app per rispondere, verificare i progressi o pianificare le quest.',
    },
    consentFooter:
      "Forza non vende i tuoi dati personali e non li condivide per pubblicita o profilazione di terze parti. Questi provider trattano i dati solo quanto serve per erogare i servizi Forza e devono garantire la stessa protezione descritta nella nostra Privacy Policy.",
    unexpectedError: 'Si e verificato un problema. Riprova.',
    noAccountFound: 'Nessun account trovato. Registrati prima per crearne uno.',
    authCreateFailed: "Autenticazione non riuscita durante la creazione dell'account. Riprova.",
    accountDeleted: 'Questo account e stato eliminato.',
    appleMissingEmail: "Accedi con Apple non ha fornito un indirizzo email per questo account.",
    appleUnavailable: 'Accedi con Apple non disponibile in questo ambiente.',
    appleUnavailableDetailed:
      "Accedi con Apple non e disponibile su questo simulatore o dispositivo. Prova su un iPhone reale se il simulatore non completa l'autenticazione Apple.",
    appleInternalError:
      "Accedi con Apple ha raggiunto Forza ma il server non ha potuto verificare il token Apple. Controlla i log backend e la configurazione del bundle Apple.",
    appleInvalidIdentity: 'Accedi con Apple non ha fornito un identificatore account valido. Riprova.',
    authFailed: 'Autenticazione non riuscita. Riprova.',
    googleLoginFailed:
      'Nessun account trovato. Crea prima un account, quindi accedi.',
    registerRequirements:
      "Per creare l'account devi accettare Termini e Privacy Policy, confermare di avere almeno 16 anni e dare il consenso al trattamento dati AI richiesto.",
    registerSuccess:
      'Account creato. Verifica la tua email prima di accedere.',
    verificationSentTitle: 'Email di verifica inviata',
    verificationSentBody:
      'Abbiamo inviato un link di verifica a {email}. Apri il link per confermare il tuo indirizzo email e attivare l’account. Controlla la posta in arrivo e anche la cartella spam o posta indesiderata.',
    verificationInitialFailure:
      'Il tuo account è stato creato, ma non è stato possibile inviare l’email di verifica. Richiedine un’altra qui sotto.',
    verificationResend: 'Invia di nuovo l’email di verifica',
    verificationResending: 'Invio in corso...',
    verificationRetryCountdown: 'Potrai richiedere un’altra email tra {seconds} secondi.',
    verificationResendError: 'Al momento non è possibile inviare un’altra email di verifica.',
    backToSignIn: 'Torna al login',
    unlockApprovalFound: 'Approvazione trovata. Conferma per sbloccare la registrazione.',
    unlockConsumed: 'Questa email approvata e gia stata usata per creare un account.',
    unlockMissing: "Questa email al momento non e approvata per l'early access.",
    unlockCheckFailed: 'Impossibile controllare lo stato di approvazione in questo momento.',
    unlockIssueFailed: 'Impossibile sbloccare la registrazione in questo momento.',
    unlockCta: 'Sblocca registrazione',
    approvedEmailWarningTitle: "Usa l'email approvata",
    approvedEmailWarningBody:
      'Questa email approvata sta per sbloccare la registrazione. Completa subito la creazione account per evitare che lo sblocco scada.',
    termsOfService: 'Termini di Servizio',
    privacyPolicy: 'Privacy Policy',
    backToAboutForza: 'Torna ad About Forza',
  },
  landingIntro: {
    startAria: "Avvia l'intro di Forza",
    subprompt: "Un'app per la longevita",
    loading: "Caricamento dell'intro...",
    enter: 'Tocca per entrare in Forza',
    preparing: 'Preparazione video...',
  },
  googleCallback: {
    processing: 'Accesso in elaborazione...',
  },
  onboarding: {
    setupTag: 'Configurazione Forza',
    modeChoiceTitle: 'Scegli il ritmo della configurazione.',
    modeChoiceDescription:
      'La configurazione rapida ti fa partire subito. Quella dettagliata da a Forza piu sfumature per un primo piano ancora piu centrato.',
    fastTitle: 'Configurazione rapida',
    fastDescription:
      'Un setup essenziale che raccoglie le basi e prepara rapidamente il primo piano.',
    fastBestFor: 'Ideale se vuoi partire subito.',
    detailedTitle: 'Configurazione dettagliata',
    detailedDescription:
      'Un setup piu profondo con misure corporee, dettagli di allenamento e preferenze app. Le unita restano metriche di default e puoi cambiarle piu tardi nelle Impostazioni.',
    detailedBestFor: 'Ideale se vuoi un piano piu personalizzato da subito.',
    loading: 'Caricamento del tuo profilo onboarding...',
    changePath: 'Cambia percorso',
    progress: 'Avanzamento',
    step: 'Step {current}',
    stepOf: 'Step {current} di {total}',
    fullName: 'Nome completo',
    age: 'Eta',
    height: 'Altezza',
    weight: 'Peso',
    gender: 'Genere',
    location: 'Localita',
    preferredUnits: 'Unita preferite',
    options: {
      gender: {
        Male: 'Uomo',
        Female: 'Donna',
        Other: 'Altro',
      },
      activity: {
        '1-2 days per week': '1-2 giorni a settimana',
        '3-4 days per week': '3-4 giorni a settimana',
        '5-6 days per week': '5-6 giorni a settimana',
        '7 days per week': '7 giorni a settimana',
      },
      dietary: {
        Vegan: 'Vegana',
        Vegetarian: 'Vegetariana',
        'Gluten-Free': 'Senza glutine',
        'Low-Carb': 'Low-carb',
        Keto: 'Keto',
      },
      workout: {
        'Strength Training': 'Forza',
        Cardio: 'Cardio',
        Yoga: 'Yoga',
        Pilates: 'Pilates',
        HIIT: 'HIIT',
        Cycling: 'Ciclismo',
        Running: 'Corsa',
        Meditation: 'Meditazione',
      },
      equipment: {
        None: 'Nessuna attrezzatura',
        Dumbbells: 'Manubri',
        'Resistance bands': 'Elastici',
        Kettlebell: 'Kettlebell',
        'Pull-up bar': 'Sbarra per trazioni',
        'Gym access': 'Accesso in palestra',
      },
      familiarity: {
        Novice: 'Sto iniziando',
        Basic: 'Conosco le basi',
        Comfortable: 'Mi alleno con scioltezza',
        Advanced: 'Mi alleno con sicurezza',
        'Expert/PT': 'Esperto / coach',
      },
      familiarityDescriptions: {
        Novice: 'Meglio partire con movimenti semplici e indicazioni molto chiare.',
        Basic: 'Conosco gli esercizi principali e preferisco sessioni lineari.',
        Comfortable: 'Gestisco bene una buona gamma di esercizi comuni.',
        Advanced: 'Sono a mio agio con varianti piu tecniche e sessioni strutturate.',
        'Expert/PT': 'Conosco programmazione, tecnica e progressioni avanzate.',
      },
      units: {
        'Metric (kg, km)': 'Metrico (kg, km)',
        'Imperial (lbs, miles)': 'Imperiale (lbs, miles)',
      },
      weekdays: {
        Mon: 'Lun',
        Tue: 'Mar',
        Wed: 'Mer',
        Thu: 'Gio',
        Fri: 'Ven',
        Sat: 'Sab',
        Sun: 'Dom',
      },
    },
    enterFullName: 'Inserisci il tuo nome completo',
    enterAge: 'Inserisci la tua eta',
    enterHeight: 'Inserisci la tua altezza',
    enterWeight: 'Inserisci il tuo peso',
    cityCountry: 'Citta, Paese',
    sessionsPerWeek: 'Sessioni a settimana',
    preferredWorkoutDays: 'Giorni preferiti di allenamento',
    preferredWorkoutDaysCount: '{selected}/{total} selezionati',
    workoutDayHint:
      'Il planner generera workout solo in questi giorni. Meal e mindfulness continueranno a comparire ogni giorno.',
    trainingContextTitle: 'Contesto di allenamento',
    trainingContextDescription:
      'Questo aiuta Forza ad allineare la tua prima settimana a esperienza, sicurezza e ritmo reale.',
    weeklyActivity: 'Attivita settimanale',
    fitnessGoals: 'Quali sono i tuoi obiettivi fitness?',
    fitnessGoalsPlaceholder: 'es. Aumentare forza, perdere grasso, tornare a sentirmi atletico...',
    tellUsAboutYourself: 'Parlaci di te',
    basicsDescription: 'Questi dati danno forma al piano, al ritmo e al tono con cui Forza ti accompagna.',
    bodyTitle: 'Misura la tua struttura',
    bodyDescription: 'Tutti i campi delle circonferenze sono facoltativi. Puoi lasciarli tutti vuoti e continuare comunque allo step successivo.',
    optionalNotes: 'Note opzionali',
    optionalNotesPlaceholder: 'Asimmetrie, focus attuale o contesto della misurazione.',
    dietaryPreferences: 'Preferenze alimentari',
    allergiesToggle: 'Ho allergie',
    allergiesPlaceholder: 'Elenca allergie o reazioni.',
    safetyNote: 'Nota di sicurezza',
    safetyDescription: 'Useremo queste informazioni per mantenere il piano sensato. Non sostituiscono un parere medico.',
    medicalConditions: 'Condizioni mediche, infortuni o dolore',
    medicalConditionsPlaceholder: 'es. Asma, dolore al ginocchio, vecchio infortunio alla spalla, oppure Nessuno.',
    preferencesTitle: "Personalizza l'esperienza",
    preferencesDescription: "Modella l'esperienza in modo che reminder, stile di allenamento e attrezzatura rispecchino la tua vita reale.",
    pushNotifications: 'Notifiche push',
    pushNotificationsDescription: 'Ricevi promemoria e aggiornamenti quest.',
    openIphoneSettings: 'Apri Impostazioni iPhone',
    favouriteWorkoutStyles: 'Stili di workout preferiti',
    equipmentYouOwn: 'Attrezzatura che possiedi',
    addCustomEquipment: 'Aggiungi attrezzatura personalizzata',
    add: 'Aggiungi',
    reviewTitle: 'Rivedi la configurazione',
    reviewDescription: 'Dai un ultimo sguardo, poi scegli se calibrare il tuo livello iniziale prima della prima generazione.',
    reviewProfile: 'Profilo',
    reviewTraining: 'Allenamento',
    reviewEquipment: 'Attrezzatura',
    reviewHealth: 'Salute e nutrizione',
    notProvided: 'Non fornito',
    none: 'Nessuno',
    name: 'Nome',
    goal: 'Obiettivo',
    familiarity: 'Familiarita',
    workoutDays: 'Giorni workout',
    workoutStyles: 'Stili workout',
    units: 'Unita',
    availableEquipment: 'Attrezzatura disponibile',
    healthNotes: 'Note salute',
    assessmentTitle: 'Fitness assessment opzionale',
    assessmentDescription:
      'Usa questo rapido check per affinare il tuo livello iniziale. Se lo salti, Forza partira in modo piu conservativo.',
    startAssessment: 'Inizia assessment',
    startAssessmentDescription: 'Scegli varianti degli esercizi e inserisci il risultato per sei domini compatibili con casa.',
    skipForNow: 'Salta per ora',
    skipForNowDescription: 'Genera ora quest iniziali conservative e mantieni assessment disponibile nelle Impostazioni.',
    selfReportTitle: 'Test fitness autovalutativo',
    selfReportDescription:
      'Scegli la variante piu difficile che controlli bene, poi inserisci il risultato dove serve. Forza la usa per impostare una baseline piu intelligente.',
    resultPlaceholder: 'Risultato',
    assessmentSafety:
      'Questa e una autovalutazione e va eseguita solo se ti senti sicuro. Fermati se qualcosa non va.',
    back: 'Indietro',
    next: 'Avanti',
    saving: 'Salvataggio...',
    continueToAssessment: 'Continua ad assessment',
    generatingQuests: 'Generazione quest...',
    submitAssessment: 'Invia assessment e genera quest',
    fastCoachIntro: 'Facciamola rapida. Prima mi servono le basi per mettere il tuo primo piano nella zona giusta.',
    fastGoalPrompt: 'Qual e il risultato che vuoi ottenere piu di tutto con il tuo primo piano?',
    fastGoalPlaceholder:
      'es. Voglio perdere grasso senza perdere forza, allenarmi 4 giorni a settimana e migliorare la costanza.',
    fastFamiliarityPrompt: 'Quanto ti senti sicuro con tecnica e varianti degli esercizi?',
    fastAvailabilityPrompt: 'In una settimana reale, quante volte riesci a presentarti per training o recovery?',
    fastEquipmentPrompt: 'Su quale attrezzatura puo davvero contare Forza?',
    fastHealthPrompt: 'Ci sono infortuni, dolori o limitazioni che il piano deve rispettare?',
    fastHealthPlaceholder: "Scrivi Nessuno se non c'e nulla da segnalare.",
    fastHealthHint: 'Se segnali un problema, Forza continuera comunque, ma il piano dovrebbe restare conservativo.',
    fastNutritionPrompt: 'Ultima cosa: ci sono preferenze alimentari o allergie che le meal quest devono rispettare?',
    errors: {
      loadProfile: 'Impossibile caricare il profilo. Aggiorna la pagina e riprova.',
      saveProgress: "Impossibile salvare l'avanzamento onboarding.",
      finalize: "Impossibile completare l'onboarding. Riprova.",
      workoutDaysExact: 'Scegli esattamente {count} giorn{suffix} di workout prima di continuare.',
      pushDisabledExternal:
        'Le notifiche push sono state disabilitate nelle Impostazioni iPhone. Riattivale li se vuoi promemoria da Forza.',
      pushDenied: 'Le notifiche sono disabilitate nelle Impostazioni iPhone. Attivale li, poi riprova.',
      pushConfig: 'Impossibile configurare le notifiche push.',
    },
    steps: {
      chooseSetup: 'Scegli setup',
      personalInfo: 'Crea il profilo',
      fitnessProfile: 'Contesto di allenamento',
      bodyComposition: 'Misure corporee',
      healthDetails: 'Elementi salute',
      preferences: 'Preferenze app',
      review: 'Rivedi e conferma',
      assessment: 'Fitness assessment',
      fastBasics: 'Basi',
      fastGoal: 'Obiettivo',
      fastFamiliarity: 'Familiarita esercizi',
      fastAvailability: 'Disponibilita settimanale',
      fastEquipment: 'Attrezzatura',
      fastHealth: 'Note salute',
      fastNutrition: 'Note nutrizione',
      fastReview: 'Riepilogo',
    },
    bodyLabels: {
      neck: 'Collo',
      chest: 'Torace',
      waist: 'Vita',
      hips: 'Fianchi',
      thigh: 'Coscia',
      circumference: 'Circonferenza {label}',
    },
    assessmentDomains: {
      push: {
        label: 'Spinta',
        prompt: 'Quante ripetizioni controllate riesci a completare?',
        variations: {
          easier: 'Push-up inclinato',
          standard: 'Push-up',
          harder: 'Push-up declinato',
        },
        variationDescriptions: {
          easier: 'Mani su muro, panca o superficie rialzata stabile. Scendi con controllo e poi spingi di nuovo su.',
          standard: 'Mani a terra e corpo in linea. Scendi con controllo e risali senza far cedere il bacino.',
          harder: 'Piedi rialzati e mani a terra. Mantieni il corpo rigido mentre scendi e risali.',
        },
      },
      squat: {
        label: 'Squat / affondo',
        prompt: 'Quante ripetizioni controllate riesci a completare?',
        variations: {
          easier: 'Box squat',
          standard: 'Air squat',
          harder: 'Affondo inverso',
        },
        variationDescriptions: {
          easier: 'Porta i glutei verso una sedia o un box, sfioralo e risali con controllo.',
          standard: 'Piedi circa alla larghezza delle spalle. Scendi in squat a corpo libero e risali senza rimbalzare.',
          harder: 'Porta una gamba indietro in affondo, scendi con controllo e torna in piedi prima di cambiare lato.',
        },
      },
      hinge: {
        label: 'Hip hinge',
        prompt: 'Quante ripetizioni controllate riesci a completare?',
        variations: {
          easier: 'Glute bridge',
          standard: 'Good morning a corpo libero',
          harder: 'Romanian deadlift a una gamba',
        },
        variationDescriptions: {
          easier: 'Sdraiato a terra con i piedi appoggiati, solleva il bacino stringendo i glutei.',
          standard: 'In piedi, porta il bacino indietro con schiena lunga e poi torna su senza incurvarti.',
          harder: 'In equilibrio su una gamba, inclina il busto dal bacino con controllo e risali senza ruotare.',
        },
      },
      core: {
        label: 'Core',
        prompt: 'Per quanto tempo riesci a mantenere una forma stabile?',
        variations: {
          easier: 'Plank sulle ginocchia',
          standard: 'Plank sugli avambracci',
          harder: 'Long-lever plank',
        },
        variationDescriptions: {
          easier: 'Mantieni una linea stabile da spalle a ginocchia tenendo attivo l addome.',
          standard: 'Mantieni il plank sugli avambracci con anche ferme e corpo in linea.',
          harder: 'Plank con i gomiti piu avanti rispetto alle spalle per aumentare la leva, senza perdere tensione.',
        },
      },
      cardio: {
        label: 'Cardio',
        prompt: 'Quanti minuti riesci a sostenere uno sforzo impegnativo ma controllato?',
        variations: {
          easier: 'Camminata sostenuta',
          standard: 'Corsa leggera o step-up',
          harder: 'Corsa veloce o burpees',
        },
        variationDescriptions: {
          easier: 'Cammina a un ritmo che alza chiaramente il respiro ma resta gestibile.',
          standard: 'Scegli una corsa leggera o step-up ripetuti che siano impegnativi ma sostenibili.',
          harder: 'Scegli corsa veloce o burpees solo se riesci a mantenere il gesto controllato e sicuro.',
        },
      },
      mobility: {
        label: 'Mobilita',
        prompt: 'Scegli il range di movimento senza dolore che controlli meglio oggi.',
        variations: {
          very_limited: 'Molto limitato o doloroso',
          limited: 'Range limitato e prudente',
          standard: 'Movimento quotidiano normale',
          deep_controlled: 'Range ampio con controllo',
          deep_unrestricted: 'Range ampio senza fastidio',
        },
        variationDescriptions: {
          very_limited: 'Il movimento si blocca presto o fa male, quindi devi fermarti molto prima di un range normale.',
          limited: 'Riesci a muoverti un po, ma il range e chiaramente ridotto e richiede prudenza.',
          standard: 'Gestisci i movimenti quotidiani normali senza grosse limitazioni.',
          deep_controlled: 'Raggiungi un range ampio restando stabile e sotto controllo.',
          deep_unrestricted: 'Ti muovi in un range ampio con comfort, senza dolore o compensi evidenti.',
        },
      },
    },
    assessmentDifficulty: {
      easier: 'Piu facile',
      standard: 'Standard',
      harder: 'Piu difficile',
      very_limited: 'Molto limitato',
      limited: 'Limitato',
      deep_controlled: 'Ampio',
      deep_unrestricted: 'Completo',
    },
    assessmentUnits: {
      reps: 'ripetizioni',
      seconds: 'secondi',
      minutes: 'minuti',
      choice: 'scelta',
    },
  },
  dashboard: {
    dailyQuests: 'Quest giornaliere',
    recoveryModeActive: 'Recovery Mode attiva',
    recoveryModeDescription: 'Completa 3 workout di recovery per ripristinare il livello pieno.',
    viewWeeklyShoppingList: 'Vedi lista spesa settimanale',
    generationFailed: 'Generazione quest fallita.',
    unknownError: 'Errore sconosciuto',
  },
  calendar: {
    title: 'Calendario',
    toggleSearch: 'Attiva o disattiva ricerca',
    toggleFilter: 'Attiva o disattiva filtro',
    toggleView: 'Attiva o disattiva vista calendario',
    searchPlaceholder: 'Cerca quest...',
    questsForDay: 'Quest del {date}',
    allScheduledQuests: 'Tutte le quest pianificate',
    noQuestsForDay: 'Nessuna quest pianificata per questo giorno.',
    noQuestsFound: 'Nessuna quest trovata.',
    generatingAfterLevelUp: 'Generazione di nuove quest dopo il level-up...',
    filters: {
      all: 'Tutte',
      workout: 'Allenamento',
      mind: 'Mind',
      mindfulness: 'Mindfulness',
      meal: 'Pasto',
    },
    errors: {
      load: 'Impossibile caricare il calendario.',
      updateQuest: 'Impossibile aggiornare questa quest in questo momento.',
      updated: 'Quest aggiornata.',
      movedTo: '{quest} spostata a {target}.',
      swappedWith: '{quest} scambiata con {target}.',
    },
  },
  header: {
    forza: 'Forza',
    leaderboard: 'Classifica',
    calendar: 'Calendario',
    settings: 'Impostazioni',
    login: 'Accedi',
    register: 'Registrati',
    navigation: 'Navigazione principale',
  },
  questCard: {
    healthKitOnly: 'Solo HealthKit',
    moveSwap: 'Sposta o scambia quest',
    completed: 'Completata',
    locked: 'Bloccata',
    viewHealthStatus: 'Vedi stato salute',
    liveCoach: 'Coach Live',
    live: 'Live',
    start: 'Avvia',
    startMindSession: 'Avvia la sessione Mind',
    verify: 'Verifica',
    verifyQuest: 'Verifica quest',
  },
  featureBanner: {
    dismiss: 'Chiudi guida',
    previous: 'Prima',
    next: 'Dopo',
    jumpTo: 'Vai alla funzione {index}',
    items: {
      adaptiveTitle: 'Forza si adatta a te',
      adaptiveDesc: 'Le quest evolvono in base a livello, costanza e obiettivi.',
      missTitle: 'Non lasciare indietro le quest',
      missDesc: 'Le quest mancate riducono XP, quindi la costanza tiene alto il ritmo.',
      coachTitle: 'AI Coach',
      coachDesc: 'Tocca il microfono di AI Coach quando vuoi un consiglio o un piano ancora piu intelligente.',
      proofTitle: 'Proof of work',
      proofDesc: 'Scatta 3 foto dei meal per verificare la quest e bloccare gli XP.',
      timedTitle: 'Sessioni workout con timer',
      timedDesc: 'Tocca Verifica, poi Avvia timer per partire con un workout guidato.',
      voiceTitle: 'Note vocali',
      voiceDesc: 'Invia una nota vocale per verificare la quest e ottenere gli XP.',
      levelTitle: 'Sali di livello',
      levelPrefix: 'Crea streak',
      levelSuffix: 'per sbloccare ricompense.',
      aurasTitle: 'Guadagna aura',
      aurasDesc: 'Ogni quest completata vale 100 Aura. Una streak di 7 giorni ne vale 1000.',
      shopTitle: 'Usa le aura con strategia',
      shopPrefix: 'Tocca',
      shopSuffix: 'per aprire lo shop e attivare i potenziamenti Forza.',
    },
  },
  consentGate: {
    summary:
      "I tuoi dati possono essere inviati a provider esterni. Il consenso e necessario per continuare a usare Forza.",
    hideDetails: 'Nascondi dettagli',
    declineConfirmation: 'Conferma rifiuto',
    declineBody:
      'Se rifiuti il consenso al trattamento dati AI, i dati del tuo account verranno eliminati o anonimizzati e verrai disconnesso.',
    goBack: 'Torna indietro',
    deleting: 'Eliminazione account...',
    declineDelete: 'Rifiuta ed elimina account',
    saving: 'Salvataggio consenso...',
  },
  emailVerification: {
    title: 'Verifica email',
    missingToken: 'Nessun token di verifica trovato. Controlla il link.',
    verifying: 'Verifica della tua email in corso...',
    success: 'Verifica completata. Ora sei autenticato. Reindirizzamento in corso...',
    unknownError: 'Si e verificato un errore sconosciuto.',
    goToLogin: 'Vai al login',
  },
  moveSwap: {
    title: 'Sposta / Scambia',
    description: 'Cambia quando avviene questa quest questa settimana.',
    unavailable: 'Non disponibile',
    cancel: 'Annulla',
    continue: 'Continua',
    confirm: 'Conferma',
    back: 'Indietro',
    saving: 'Salvataggio...',
    optionMoveHere: 'Sposta qui',
    optionSwapWith: 'Scambia con {target}',
    moveTo: 'Spostare a {target}?',
    swapWith: 'Scambiare con {target}?',
    actions: {
      swap: 'Scambia',
      move: 'Sposta',
    },
    reasons: {
      currentDay: 'Giorno corrente',
      completedQuest: 'Quest completata',
      completedWorkout: 'Allenamento completato',
      earlierEmptyDay: 'Giorno precedente vuoto',
      unavailable: 'Non disponibile',
      noMatchingQuest: 'Nessuna quest corrispondente',
      noMindfulnessQuest: 'Nessuna quest mindfulness',
    },
  },
  modal: {
    close: 'Chiudi',
  },
  recoveryModal: {
    title: 'Recovery Mode attiva',
    subtitle: 'Bentornato',
    body1:
      'Abbiamo notato che mancavi da un po\'. Invece di abbassare il tuo livello, abbiamo attivato la Recovery Mode.',
    body2:
      'Il tuo livello e stato preservato. Prima di tornare al pieno allenamento, Forza suggerisce qualche giorno di attivita piu leggera come yoga, camminata o stretching.',
    quote: 'Il riposo non e inattivita, e la chiave per performare meglio.',
    dontShowAgain: 'Non mostrare piu',
    cta: 'Inizia recovery',
  },
  questDetails: {
    mediaReported: 'Media segnalato',
    reportingMedia: 'Segnalazione media...',
    reportInaccurateMedia: 'Segnala media non accurato',
    mediaUnavailable: 'L\'immagine sara disponibile a breve',
    aiGeneratedNotice: 'Media generato dall\'AI. Leggi la descrizione per una forma corretta.',
    expandMedia: 'Espandi {label}',
    exerciseVideoAlt: 'Video esercizio',
    exerciseImageAlt: 'Immagine esercizio',
    mealImageAlt: 'Immagine meal',
    closeExpandedImage: 'Chiudi immagine espansa',
    time: 'Tempo',
    calories: 'Calorie',
    sets: 'Serie',
    reps: 'Ripetizioni',
    rest: 'Recupero',
    seconds: '{count} secondi',
    suggestedWeight: 'Peso suggerito',
    estimatedCalories: 'Calorie stimate',
    protein: 'Proteine',
    carbs: 'Carboidrati',
    fat: 'Grassi',
    ingredients: 'Ingredienti',
    instructions: 'Istruzioni',
    current: 'Attuale',
    verification: 'Verifica',
    locked: 'Bloccato',
    automatic: 'Automatica',
    healthKitLockedBody: 'Attiva HealthKit su iPhone nell\'app Forza per sbloccare questa quest. Forza potra quindi usare i tuoi dati Apple Health per tracciare i progressi e segnare la quest come completata quando l\'obiettivo viene registrato.',
    healthKitActiveBody: 'Questa quest usa i dati Apple Health per la verifica. La sincronizzazione avviene nell\'app iPhone all\'apertura e quando torna in primo piano.',
    imageReportedForReview: 'Immagine segnalata per revisione.',
    reportImageFailed: 'Impossibile segnalare immagine.',
    detailsTitle: 'Dettagli {type}',
    viewSession: 'Apri la sessione Mind',
    viewRecipe: 'Vedi ricetta e nutrizione',
    viewHealth: 'Vedi verifica salute',
    viewRoutine: 'Vedi routine completa',
    expandedMedia: 'Media quest espanso',
    roundsLabel: 'Round',
    roundLabel: 'Round {number}',
    mindArchetype: 'Ragionamento logico',
    mindSummary: 'Completa quattro brevi round per concludere la quest Mind di oggi.',
    mindRepeatDistance: 'La stessa prova non verrà riproposta per almeno {days} giorni.',
    na: 'N/D',
  },
  verificationModal: {
    checkingVoiceAvailability: 'Controllo disponibilita nota vocale...',
    microphoneDenied: 'Accesso al microfono negato. Abilitalo nelle impostazioni del browser.',
    recordVoicePrompt: 'Registra la tua voce per la verifica.',
    verifying: 'Verifica con AI in corso...',
    levelUp: 'Level Up! Hai raggiunto il Livello {level}!',
    failed: 'Verifica non riuscita. Riprova.',
    mealSubmitted: 'Verifica meal inviata.',
    dailySubmitted: 'Invio pasti giornalieri registrato.',
    verifyingQuestTitle: 'Verifica quest in corso...',
    didYouKnow: 'Lo sapevi?',
    seeSources: 'Vedi fonti',
    title: 'Verifica Quest',
    mealDescription: 'Scegli il metodo di verifica. Acquisisci il meal oppure invia una nota vocale.',
    standardDescription: 'Scegli il metodo di verifica. Puoi registrare una nota vocale o avviare un timer guidato.',
    startMealCapture: 'Avvia acquisizione meal',
    checkingShort: 'Controllo...',
    ultraMembers: 'Solo Ultra',
    unavailable: 'Non disponibile',
    completeAllMeals: 'Completa tutti i pasti di oggi',
    alreadySentToday: 'Gia inviato oggi',
    recording: 'Registrazione...',
    voiceNote: 'Nota vocale',
    startTimer: 'Avvia timer',
    checkingFeatureAvailability: 'Controllo disponibilita funzione...',
    voiceRecorded: 'Nota vocale registrata ({size} KB)',
    cancel: 'Annulla',
    submitVoiceNote: 'Invia nota vocale',
  },
  mindSession: {
    category: 'Attivazione mentale',
    close: 'Chiudi',
    unavailable: 'Questa sessione Mind non è disponibile in questo momento.',
    roundProgress: 'Round {current} di {total}',
    yourOrder: 'Il tuo ordine',
    undo: 'Annulla',
    clear: 'Cancella',
    tapToBuild: 'Tocca una tessera',
    availableTiles: 'Tessere disponibili',
    failedChecks: 'Tentativi errati',
    roundValue: 'Massimo {value} punti',
    checkRound: 'Verifica il round',
    completeQuest: 'Completa la quest Mind',
    saving: 'Salvataggio...',
    finishSequence: 'Completa la sequenza prima di verificare il round.',
    tryAgain: 'Risposta errata. Controllala e riprova.',
    roundCleared: 'Round completato. Passa alla prova successiva.',
    lockingQuest: 'Registrazione della sessione Mind...',
    submitFailed: 'Al momento non è possibile registrare la sessione. Riprova.',
    completedToday: 'Sessione Mind completata.',
    completeLabel: 'Sessione completata',
    completedBody: 'La sessione Mind di oggi è conclusa. Torna domani per una nuova sfida.',
    score: 'Punteggio',
    rounds: 'Round',
    perfect: 'Perfetti',
    badge: 'Riconoscimento',
    zeroDrift: 'Percorso perfetto',
    cleanControl: 'Controllo preciso',
    sharpFinish: 'Finale brillante',
    previewing: 'Memorizza ciò che vedi. Potrai rispondere al termine dell’anteprima.',
    previewSequence: 'Sequenza da memorizzare',
    replayPreview: 'Rivedi l’anteprima',
    replayPreviewCount: 'Rivedi l’anteprima ({used}/{total})',
    startPreview: 'Avvia l’anteprima',
    step: 'Elemento {number}',
    finishPattern: 'Seleziona tutte le caselle richieste prima di verificare il round.',
    tryAgainPattern: 'La disposizione non è corretta. Modificala e riprova.',
    selectAllTargets: 'Seleziona tutti gli elementi corretti prima di verificare il round.',
    finishRule: 'Completa la regola attiva prima di continuare.',
    nextRuleReady: 'Prima regola completata. Ora applica quella successiva.',
    nextRule: 'Regola successiva',
    targetMiss: 'Elemento errato. Continua.',
    targetExactMatch: 'La selezione contiene elementi errati. Rimuovili e riprova.',
    ruleMiss: 'Questo elemento non rispetta la regola attiva.',
    ruleExactMatch: 'Alcuni elementi non rispettano la regola attiva. Correggi la selezione e riprova.',
    gridPrompt: 'Ricostruisci la disposizione mostrata',
    ruleStage: 'Regola attiva',
    targetSet: 'Elementi disponibili',
    backToDashboard: 'Torna alla dashboard',
    rotationStart: 'Orientamento iniziale',
    clockwise: 'Senso orario',
    counterClockwise: 'Senso antiorario',
    completeBadge: 'Mind completata',
    signalLadder: 'Progressione',
    missingStepProgress: 'Passaggio mancante {current} di {total}',
    chooseMissingStep: 'Scegli il passaggio mancante prima di controllare il round.',
    progressionMismatch: 'Questo passaggio non completa la progressione. Riprova.',
    mirrorAxis: 'Rifletti da sinistra a destra',
    classifyCards: 'Classifica ogni carta',
    classifyEveryCard: 'Assegna ogni carta prima di controllare il round.',
    classificationMismatch: 'Alcune carte sono nella categoria sbagliata. Controlla entrambe le categorie e riprova.',
    discardTitle: 'Abbandonare questa sessione Mind?',
    discardBody: 'I progressi attuali andranno persi.',
    keepPlaying: 'Continua a giocare',
    discard: 'Abbandona',
    reverseOrderHint: 'Parti dall’ultimo elemento e procedi a ritroso.',
    forwardOrderHint: 'Ricostruisci la sequenza nello stesso ordine.',
    optionsCanRepeat: 'Le opzioni possono ripetersi',
    modeProgress: 'Regola',
    rememberedSequence: 'Sequenza da ricordare',
    studyTraits: 'Osserva l’ordine e le caratteristiche di ogni carta.',
    memorizeOrder: 'Memorizza ogni elemento nell’ordine in cui appare.',
    yourFilteredSequence: 'La tua sequenza filtrata',
    yourReverseSequence: 'La tua sequenza al contrario',
    placeMatchingCards: 'Inserisci qui le carte corrette, mantenendo l’ordine originale.',
    fillSlotsInOrder: 'Completa tutti gli spazi numerati rispettando l’ordine.',
    tapCardBelow: 'Tocca una carta qui sotto',
    candidateCards: 'Carte disponibili',
    selectFilteredCards: 'Scegli le carte che rispettano la regola senza cambiarne l’ordine.',
    mirrorPattern: 'Rifletti la disposizione',
    copyOppositeSide: 'Usa lo schema di partenza come riferimento e riproducilo sul lato opposto.',
    repeatFlashOrder: 'Tocca le caselle nello stesso ordine in cui si sono illuminate.',
    sourcePattern: 'Schema di partenza',
    yourMirror: 'La tua disposizione riflessa',
    followVisualTrait: 'Segui la caratteristica visiva della carta: la parola scritta può essere in contrasto.',
    chooseCategoryEveryCard: 'Assegna ogni elemento a una delle due categorie.',
    gridCellLabel: 'Casella {number}{selected}',
    gridCellSelected: ', selezionata',
    filterRule: 'Scegli solo {rule}, mantenendo l’ordine originale.',
    warmTrait: 'Caldo',
    coolTrait: 'Freddo',
    roundedTrait: 'Arrotondata',
    angularTrait: 'Angolare',
  },
  mealCapture: {
    allAnglesCaptured: 'Tutte le angolazioni richieste sono state acquisite.',
    cameraPreviewNotReady: 'Anteprima fotocamera non pronta.',
    angleCaptured: 'Angolazione {angle} acquisita.',
    discardConfirm: 'Vuoi scartare le foto acquisite e uscire?',
    captureAllAngles: 'Acquisisci tutte e tre le angolazioni prima di inviare.',
    submitting: 'Invio foto per la verifica...',
    failed: 'Verifica meal non riuscita. Riprova.',
    rearCamera: 'Posteriore',
    frontCamera: 'Frontale',
    back: 'Indietro',
    title: 'Verifica Meal',
    deviceCamera: 'Dispositivo: fotocamera {camera}',
    initializingCamera: 'Inizializzazione fotocamera...',
    cameraRequired: 'L\'accesso alla fotocamera e richiesto per la verifica meal. Passa a un dispositivo con fotocamera.',
    captureInstruction: 'Istruzione di acquisizione',
    captureButton: 'Acquisisci {angle}',
    switch: 'Cambia',
    captureProgress: 'Avanzamento acquisizione',
    angleLabel: 'Angolo {angle}',
    captured: 'Acquisito',
    pending: 'In attesa',
    awaitingTurn: 'In coda',
    retake: 'Rifai',
    anglePreview: 'Anteprima {angle}',
    descriptionOptional: 'Descrizione (opzionale)',
    descriptionPlaceholder: 'Aggiungi eventuali dettagli che vuoi condividere...',
    cancel: 'Annulla',
    submittingShort: 'Invio...',
    submitPhotos: 'Invia foto',
    anglePrompts: {
      top: 'Acquisisci prima la vista dall\'alto.',
      front: 'Acquisisci poi la vista frontale.',
      side: 'Acquisisci per ultima la vista laterale.',
    },
  },
  formCheck: {
    rearCameraTip: 'Se possibile, passa alla fotocamera posteriore per un campo visivo piu ampio.',
    accessingCamera: 'Accesso alla fotocamera... consenti il permesso se richiesto.',
    close: 'Chiudi',
    switchCameraLens: 'Cambia lente fotocamera',
    switching: 'Cambio...',
    switchLens: 'Cambia lente',
    startingIn: 'Partenza tra',
    previewInstruction: 'Assicurati che tutto il corpo entri nell\'inquadratura e che la luce sia buona. Esegui l\'esercizio per circa 15 secondi dopo il countdown.',
    currentCamera: 'Fotocamera attuale: {camera}',
    rear: 'Posteriore',
    front: 'Frontale',
    stopCountdown: 'Ferma countdown',
    beginCapture: 'Inizia acquisizione',
    cancel: 'Annulla',
    capturing: 'Acquisizione',
    captureInstruction: 'Continua il movimento in modo naturale mentre acquisiamo circa 18 frame della tua tecnica.',
    progress: 'Progresso',
    stayInFrame: 'Resta nell\'inquadratura finche la barra non si completa. Ci fermeremo automaticamente quando avremo abbastanza movimento.',
    facingModeHint: '{message} I browser trattano facingMode come un suggerimento.',
    cancelCapture: 'Annulla acquisizione',
    analyzing: 'Analisi postura in corso... dovrebbe richiedere solo un momento.',
    couldNotComplete: 'Form Check non completato',
    poseLandmarkScore: 'Punteggio landmark postura: {score}',
    lightingScore: 'Punteggio illuminazione: {score}',
    poseQualityTip: 'Suggerimento: allontana la fotocamera cosi spalle e anche restano visibili.',
    qualityReadFailure:
      'Non siamo riusciti a leggere la tua tecnica in modo coerente. Prova ad allontanarti cosi spalle e anche restano visibili e assicurati che la luce sia uniforme.',
    tryAgain: 'Riprova',
    verdictPass: 'SUPERATO',
    verdictBorderline: 'AL LIMITE',
    verdictFail: 'NON SUPERATO',
    unknown: 'SCONOSCIUTO',
    noAdditionalTips: 'Il provider non ha restituito suggerimenti aggiuntivi.',
    preparingAudio: 'Preparazione audio...',
    replayTips: 'Riascolta suggerimenti',
    playTips: 'Riproduci suggerimenti',
    runAgain: 'Esegui di nuovo',
    whatWeMeasured: 'Cosa abbiamo misurato',
    framesUsed: 'Frame usati: {value}',
    landmarkOkRatio: 'Rapporto landmark OK: {value}',
    provider: 'Provider: {value}',
    flags: 'Flag: {value}',
    none: 'nessuno',
    uploadedBytes: 'Byte caricati (stima): {value} KB',
    camera: 'Fotocamera: {value}',
    unknownLower: 'sconosciuta',
    closeFormCheck: 'Chiudi Form Check',
    title: 'AI Form Check',
    description: 'Registra il tuo esercizio per ricevere osservazioni AI sulla tecnica. I risultati sono informativi e non sostituiscono un coach professionista.',
    startRecording: 'Avvia registrazione',
    privacyNote: 'Elaboriamo alcuni frame con AI sicura. Conserviamo solo i punteggi e non salviamo immagini.',
    consentNote: 'Avviando Form Check acconsenti al processamento off-device per l\'analisi della postura.',
    modalTitle: 'Form Check',
    requestFailed: 'Form Check non riuscito. Riprova.',
  },
  rewardedUnlock: {
    progress: 'Progresso sblocco: {completed}/{required}',
    upgrade: 'Passa a Ultra',
    genericExtra: 'Sblocca un extra per {targetLabel}',
    fallbackGeneric: 'Apri l\'app Forza su iPhone per sbloccare questo accesso bonus.',
    voiceCoach: {
      headline: 'Tocca per avviare il tuo Forza AI Coach',
      body: 'Ottieni l\'accesso completo a Voice Coach con Ultra. Preferisci una spinta rapida? Guarda brevi annunci per sbloccare 1 minuto bonus.',
      button: 'Sblocca 1 minuto bonus',
      fallback: 'Apri l\'app Forza su iPhone per sbloccare un minuto bonus.',
    },
    voiceNote: {
      headline: 'Ti serve un altro controllo vocale? Sblocca una nota vocale extra.',
      button: 'Sblocca nota vocale extra',
    },
    mealDay: {
      headline: 'Ti serve un altro check-in pasti oggi? Sblocca un check-in bonus.',
      button: 'Sblocca check-in bonus',
    },
    questReschedule: {
      headline: 'Vuoi un altro refresh del piano oggi? Sblocca un refresh extra.',
      button: 'Sblocca refresh extra',
    },
    default: {
      headline: 'Sblocca accesso bonus.',
      button: 'Sblocca accesso bonus',
    },
  },
  aiCoach: {
    phaseStarting: 'Connessione…',
    phaseListening: 'In ascolto…',
    phaseTranscribing: 'Trascrizione…',
    phaseThinking: 'Sto pensando…',
    phaseSpeaking: 'Sto parlando…',
    statusPreparingOnDeviceVoice: 'Preparazione voce sul dispositivo…',
    statusOnDeviceVoiceReady: 'La voce sul dispositivo e pronta',
    cloudVoiceDescriptionFree: 'Partenza piu rapida. Gli utenti free potrebbero comunque dover sbloccare brevi sessioni con gli annunci.',
    cloudVoiceDescriptionPaid: 'Partenza piu rapida. Usa la voce cloud invece del motore locale.',
    onDeviceVoiceReadyLabel: 'Voce sul dispositivo',
    onDeviceVoiceWarmingLabel: 'Voce sul dispositivo (riscaldamento…)',
    cloudVoiceLabel: 'Voce cloud',
    monthlyLimitReached: 'Limite mensile AI Coach raggiunto.',
    fallbackFailed: 'Fallback Voice Coach non riuscito. Riprova.',
    quotaLocked: 'Voice Coach bloccato.',
    idleTimeout: 'Sessione chiusa per inattivita.',
    genericError: 'Errore Voice Coach.',
    kokoroFallback: 'Kokoro non riuscito. Passo al TTS server.',
    micUnavailableHttp:
      'Il microfono di Voice Coach non e disponibile su HTTP non sicuro nel WebView iOS. Usa HTTPS per EXPO_PUBLIC_WEB_BASE_URL e ricompila il client dev.',
    micUnavailableGeneric: 'API microfono non disponibile in questo ambiente. Apri Forza in un contesto HTTPS sicuro e riprova.',
    micPermissionDenied: 'Permesso microfono negato. Abilita l\'accesso al microfono e riprova.',
    micNotFound: 'Nessun microfono utilizzabile trovato. Controlla i permessi microfono su iPhone e riprova.',
    sessionStartFailed: 'Impossibile avviare la sessione vocale.',
    rewardedAdsNativeOnly: 'Gli annunci reward sono disponibili nell\'app iOS.',
    unlockPendingVerification: 'Il minuto bonus e quasi pronto. In attesa della verifica...',
    openingUnlock: 'Apertura sblocco...',
    sessionTitle: 'Avvia sessione AI Coach',
    sessionTitleLimit: 'Limite mensile AI Coach raggiunto.',
    statusPrefix: 'Stato:',
    offlineMode: '(offline: {mode})',
    ttsPrefix: 'TTS:',
    ttsError: '(errore)',
    ttsPlaying: '(in riproduzione)',
    httpFallbackActive: 'Fallback HTTP attivo',
    limitReachedBody: 'Hai raggiunto il tuo limite mensile.',
    upgradePrompt: 'Vuoi accesso completo?',
    upgradeCta: 'Passa a Ultra',
    voiceModalTitle: 'Scegli la tua voce',
    voiceModalRecommendedBadge: 'Consigliato',
    voiceModalRecommendedTitle: 'Ideale per usare AI Coach con regolarita',
    voiceModalRecommendedBody:
      'Scaricare la voce sul dispositivo e una configurazione una tantum. Dopo, il coaching vocale dura di piu senza sblocchi ripetuti con annunci.',
    voiceModalDownloadTitle: 'Scarica la voce su questo iPhone',
    voiceModalDownloadBody: 'Configurazione una tantum, circa 300 MB.',
    voiceModalCloudTitle: 'Usa subito la voce cloud',
    voiceModalLater: 'Forse piu tardi',
    readyModalTitle: 'Voce sul dispositivo pronta',
    readyModalHeadline: 'Ora e disponibile un coaching vocale piu lungo',
    readyModalBody: 'La prima configurazione e completata. Le prossime sessioni vocali sul dispositivo dovrebbero partire molto piu velocemente.',
    readyModalStartTitle: 'Inizia ad ascoltare',
    readyModalStartBody: 'Avvia ora la tua prima sessione vocale sul dispositivo.',
    readyModalCloudTitle: 'Usa invece la voce cloud',
    readyModalCloudBody: 'Salta il percorso locale per questa sessione e inizia subito con la voce cloud.',
  },
  liveCoach: {
    limitReachedTitle: 'Limite mensile raggiunto',
    limitReachedBody: 'Hai usato tutti i minuti AI Coach di questo mese. Passa a un piano superiore per averne altri.',
    connectionErrorTitle: 'Errore di connessione',
    connectionUnavailable: 'Connessione Live Coach non disponibile. Chiudi e riprova.',
    audioSendFailed: 'Invio audio Live Coach non riuscito. Chiudi e riprova.',
    microphoneStartFailed: 'Avvio microfono Live Coach non riuscito. Chiudi e riprova.',
    wrongQuestContext: 'Live Coach non ha ricevuto il contesto della quest selezionata. Chiudi e riprova.',
    connectionClosed: 'Connessione Live Coach chiusa.',
    connectionFailed: 'Connessione Live Coach non riuscita.',
    genericError: 'Errore Live Coach.',
    inactiveTimeout: 'Sessione chiusa per inattivita.',
    connectFailed: 'Impossibile connettersi.',
    sessionCreateFailed: 'Impossibile creare la sessione Live Coach.',
    handshakeTimeout: 'L\'handshake di Live Coach non è stato completato. Riavvia il server e riprova.',
    readyTimeout: 'Live Coach non ha finito di preparare la quest selezionata. Chiudi e riprova.',
    loading: 'Connessione ad AI Coach...',
    usageCacheWarning: 'Impossibile aggiornare l\'utilizzo. Uso quota in cache.',
    ready: 'Live Coach pronto',
    preparing: 'Preparazione workout...',
    connecting: 'Connessione...',
  },
  leaderboard: {
    pageTitle: 'Classifica',
    tabs: {
      global: 'Globale',
      regional: 'Regionale',
      myLeague: 'La mia lega',
      duel: 'Duello',
    },
    loading: 'Caricamento classifica...',
    loadingDuel: 'Caricamento stato duello...',
    loadFailed: 'Impossibile caricare i dati. Riprova piu tardi.',
    noData: 'Nessun dato classifica',
    noActiveOrPendingDuels: 'Nessun duello attivo o in attesa.',
    globalRankings: 'Classifica globale',
    locationTitle: 'Posizione: {location}',
    leagueFallback: 'Lega',
    tierFallback: 'Tier',
    myRank: 'La tua posizione: {rank} / {total}',
    currentRivalry: 'Rivalita attuale',
    view: 'Vedi',
    openDuel: 'Apri duello',
    review: 'Controlla',
    opponent: 'Avversario',
    you: 'Tu',
    youVs: 'Tu vs {opponent}',
    challengedYou: '{opponent} ti ha sfidato',
    youChallenged: 'Hai sfidato {opponent}',
    timeLeft: '{time} rimasti',
    expiresIn: 'Scade tra {time}',
    sentExpiresIn: 'Inviata · scade tra {time}',
    lead: 'Vantaggio: {value} XP',
    rewardOnWin: 'Ricompensa in caso di vittoria: {reward}',
    incomingChallenges: 'Sfide in arrivo',
    outgoingChallenges: 'Sfide inviate',
    recentHistory: 'Ultime 5',
    win: 'Vittoria',
    loss: 'Sconfitta',
    tie: 'Pareggio',
    resultVs: '{result} vs {opponent}',
    available: 'Disponibile',
    pending: 'In attesa',
    inDuel: 'In duello',
    unavailable: 'Non disponibile',
    limitReached: 'Limite raggiunto',
    sendChallenge: 'Invia sfida',
    acceptChallenge: 'Accetta sfida',
    decline: 'Rifiuta',
    cancel: 'Annulla',
    working: 'Operazione in corso...',
    helperDefault: 'Duello di 7 giorni. Punteggio = tutti gli XP guadagnati durante la sfida.',
    helperActiveDuelUser: 'Questo utente e gia in un duello. Tempo rimanente: {time}.',
    helperPendingIncoming: 'Questo utente ti ha gia sfidato.',
    helperPendingOutgoing: 'Hai gia una sfida in attesa con questo utente.',
    helperActiveDuelSelf: 'Hai gia un duello attivo. Concludilo prima di inviare una nuova sfida.',
    helperOutgoingLimit: 'Hai gia 3 sfide in uscita in attesa.',
    level: 'Livello {level}',
    monthlyXp: 'XP mensili: {xp}',
    lastFive: 'Ultime 5: {record}',
    status: 'Stato: {status}',
    winnerReward: 'Vincitore: {reward}',
    tieReward: 'Pareggio: {reward}',
    locationModalTitle: 'Imposta la tua posizione',
    locationModalBody: 'Per vedere la classifica regionale, indica il tuo paese.',
    locationPlaceholder: 'es. Italia',
    locationInvalid: 'Inserisci un paese valido.',
    locationSaveFailed: 'Impossibile salvare la posizione.',
    save: 'Salva',
    savedToast: 'Posizione salvata',
    challengeSent: 'Sfida inviata',
    challengeAccepted: 'Sfida accettata',
    challengeDeclined: 'Sfida rifiutata',
    sendChallengeFailed: 'Invio sfida non riuscito.',
    acceptChallengeFailed: 'Accettazione sfida non riuscita.',
    declineChallengeFailed: 'Rifiuto sfida non riuscito.',
    winRewardValue: '750 Aura + 200 XP',
    tieRewardValue: '375 Aura + 100 XP ciascuno',
  },
  subscription: {
    badge: 'Forza Ultra',
    heroTitle: 'Allenamenti guidati, verifiche piu rapide e piu controllo.',
    heroBody:
      'Ultra è pensato per chi vuole coaching AI hands-free, Form Check durante il workout e piu flessibilita quando il piano cambia.',
    currentPlan: 'Piano attuale',
    active: 'Attivo',
    monthly: 'Mensile',
    billingNote: 'Si rinnova ogni mese finche non annulli. Puoi annullare in qualsiasi momento dalle impostazioni abbonamenti del tuo account Apple.',
    refreshEntitlement: 'Aggiorna entitlement server',
    signInBeforePurchasing: 'Accedi prima di acquistare Ultra',
    nativeUnavailable: 'Apri Forza su iPhone per acquistare, ripristinare o gestire Ultra con Apple IAP.',
    paymentNoticeLead: 'Il pagamento viene elaborato da Apple. Acquistando, accetti i',
    and: 'e',
    actions: {
      purchase: 'Avvia Ultra nell\'app iOS',
      restore: 'Hai gia un abbonamento? Ripristina acquisto',
      manage: 'Gestisci abbonamento',
    },
    status: {
      pending: '{action} avviata...',
      genericAction: 'Azione abbonamento',
      successActive: 'L\'accesso Ultra e attivo su questo account.',
      successInactive: 'Stato acquisto aggiornato. Ultra non e ancora attivo.',
      cancelled: 'Acquisto annullato.',
      failed: 'Azione abbonamento non riuscita.',
      refreshing: 'Aggiornamento stato abbonamento...',
      refreshFailed: 'Impossibile aggiornare lo stato dell\'abbonamento.',
    },
    planNames: {
      ultra: 'Ultra',
      freeTier: 'Piano gratuito',
    },
    renewalLabel: 'Si rinnova o scade il {date}',
    features: {
      handsFreeTitle: 'AI Coach hands-free durante i workout',
      handsFreeBody: 'Avvia coaching vocale guidato senza guardare annunci prima, cosi puoi allenarti senza fissare il telefono.',
      formCheckTitle: 'Form Check dentro il timer workout',
      formCheckBody: 'Apri Form Check direttamente nelle sessioni con timer quando vuoi feedback sulla postura a metà workout.',
      higherLimitsTitle: 'Limiti piu alti tra voce, meal e form check',
      higherLimitsBody: 'Ottieni una quota inclusa piu ampia per feedback regolari su note vocali, verifica meal e form check.',
      rescheduleTitle: 'Piu margine per riprogrammare il piano',
      rescheduleBody: 'Regola piu spesso obiettivi e rigenerazione dei workout settimanali quando cambiano i tuoi impegni.',
    },
  },
  healthSources: {
    eyebrow: 'Fonti e disclaimer',
    title: 'Fonti salute',
    intro:
      'Questa pagina elenca i riferimenti di salute pubblica dietro ai consigli che vedi in Forza e spiega quali numeri nell\'app sono impostazioni di prodotto e non consigli medici personalizzati.',
    lastUpdated: 'Ultimo aggiornamento:',
    medicalDisclaimerTitle: 'Disclaimer medico',
    medicalDisclaimerBody:
      'Forza e un\'app wellness, non un dispositivo medico. Tutto cio che trovi nell\'app - piani, target, consigli di coaching e libreria dei fatti - ha solo scopo informativo generale e non sostituisce un parere medico professionale. Rivolgiti a un professionista qualificato prima di iniziare o modificare una routine di esercizio, nutrizione o sonno, soprattutto se hai una condizione medica, un infortunio o stai assumendo farmaci.',
    searchLabel: 'Cerca ID fact, ID fonte o parole chiave',
    searchPlaceholder: 'Prova F001, sonno, proteine, ACT-CDC...',
    referencesTitle: 'Riferimenti di salute pubblica',
    planningDefaultsTitle: 'Impostazioni predefinite di Forza',
    planningDefaultsBody: 'Questi sono i valori iniziali che Forza usa per costruire il tuo piano. Sono impostazioni di prodotto, non prescrizioni mediche.',
    factLibraryTitle: 'Libreria dei fatti e fonti',
    openSource: 'Apri fonte',
    sourceCountOne: '{count} fonte',
    sourceCountOther: '{count} fonti',
    defaultCountOne: '{count} impostazione',
    defaultCountOther: '{count} impostazioni',
    factCountOne: '{count} fatto',
    factCountOther: '{count} fatti',
  },
  questGenerationLoading: {
    title: 'Sto costruendo il tuo piano...',
    subtitle: 'Sto rivedendo preferenze e obiettivi',
    alreadyRunningTitle: 'Rigenerazione delle quest gia in corso...',
    alreadyRunningSubtitle: 'Riconnessione a una generazione gia avviata',
    restartedTitle: 'Riavvio del tuo piano...',
    restartedSubtitle: 'Una generazione bloccata precedente e stata chiusa automaticamente',
    errorTitle: 'Generazione quest non riuscita',
    errorBody: 'Riprova piu tardi o contatta il supporto.',
    initiating: 'Avvio',
    finalizing: 'Finalizzazione',
    didYouKnow: 'Lo sapevi?',
    seeSources: 'Vedi fonti',
  },
  shop: {
    balanceLabel: 'Aura',
    available: 'disponibili',
    intro: 'Usa le Aura per proteggere le streak, aumentare gli XP e recuperare senza perdere ritmo.',
    activeBoosts: 'Boost attivi',
    activeCount: '{count} attivi',
    noActiveBoosts: 'Nessun boost attivo',
    inventoryTitle: 'Inventario boost',
    inventorySubtitle: 'Compra ora, attiva quando il momento conta.',
    owned: 'Posseduti: {count}',
    activeWithTime: 'Attivo · {time}',
    activeItemWithTime: '{itemName} · {time}',
    buy: 'Compra',
    activate: 'Attiva',
    extend: 'Estendi +24h',
    buyTitle: 'Compra {itemName}',
    buyBody: 'Aggiungi 1 {itemName} al tuo inventario. Potrai attivarlo piu tardi.',
    activateTitle: 'Attiva {itemName}',
    activateBody: 'Attiva {itemName} per 24 ore e consuma 1 oggetto posseduto.',
    extendTitle: 'Estendi {itemName}',
    extendBody: 'Estendi {itemName} di 24 ore e consuma 1 oggetto posseduto.',
    cost: 'Costo',
    consumes: 'Consuma',
    oneItem: '1 oggetto',
    ownedLabel: 'Posseduti',
    cancel: 'Annulla',
    loadFailed: 'Impossibile caricare i dati Aura',
    purchaseFailed: 'Acquisto non riuscito',
    activationFailed: 'Attivazione non riuscita',
    purchasedToast: '{itemName} acquistato',
    activatedToast: '{itemName} attivato',
    extendedToast: '{itemName} esteso di +24h',
    expired: 'Scaduto',
    items: {
      icebath: {
        name: 'Bagno di ghiaccio',
        subtitle: 'Blocco streak',
        description: 'Congela la tua streak per 24h per recuperare.',
      },
      preworkout: {
        name: 'Pre-workout',
        subtitle: 'Boost XP',
        description: '2x XP sulle quest per le prossime 24h.',
      },
      cheatmeal: {
        name: 'Cheat Meal',
        subtitle: 'Scudo penalita',
        description: 'Nessuna penalita XP per 24h.',
      },
    },
  },
  shoppingList: {
    loadFailed: 'Impossibile caricare la lista della spesa.',
    title: 'Lista spesa di 7 giorni',
    subtitle: 'Generata dai meal di questa settimana',
    close: 'Chiudi lista della spesa',
    loading: 'Estrazione ingredienti...',
    empty: 'Nessuna meal quest in arrivo trovata per questa settimana.',
    syncing: 'Sincronizzazione...',
    toggleItem: 'Attiva o disattiva {item}',
  },
  dailyMealCheckin: {
    meals: {
      breakfast: 'Colazione',
      lunch: 'Pranzo',
      dinner: 'Cena',
      snack: 'Snack / Altro',
    },
    earnedToday: 'Ottenuti oggi',
    aiAnalysis: 'Analisi AI',
    matchScore: '{value}% MATCH',
    calories: 'Calorie',
    protein: 'Proteine',
    carbs: 'Carboidrati',
    fat: 'Grassi sat.',
    draftSaved: 'Bozza salvata in locale.',
    tooLong: '{meal} supera i {max} caratteri.',
    requiredUnlessCompleted: '{meal} e obbligatorio salvo completamento gia registrato.',
    checkingAvailability: 'Controllo disponibilita check-in pasti...',
    unavailable: 'Check-in pasti non disponibile in questo momento.',
    analyzingMeals: 'Analisi pasti in corso...',
    submitFailed: 'Invio non riuscito. Riprova.',
    completed: 'Completato',
    placeholder: 'Cosa hai mangiato per {meal}?',
    dailySummary: 'Riepilogo giornaliero',
    title: 'Check-in pasti giornaliero',
    levelUp: 'Level Up!',
    welcomeLevel: 'Benvenuto al Livello {level}',
    continue: 'Continua',
    saveDraft: 'Salva bozza',
    checkingShort: 'Controllo...',
    alreadySent: 'Gia inviato',
    sendDailyCheckin: 'Invia check-in giornaliero',
  },
  timerSession: {
    rest: 'Riposo',
    workout: 'Workout',
    recovery: 'Recupero',
    next: 'Prossimo',
    seconds: '{count} secondi',
    backToVerification: 'Torna alla verifica',
    workoutTracker: 'Tracker workout',
    timerPaused: 'Timer in pausa',
    done: 'Fatto',
    noTrackableExercises: 'Nessun esercizio tracciabile disponibile per questa quest.',
    targetValue: 'Target {value}',
    setNumber: 'Set {number}',
    setProgress: 'Set {current}/{total}',
    reps: 'Reps',
    weightUnit: 'Peso {unit}',
    submittingVerification: 'Invio verifica...',
    errorOccurred: 'Si e verificato un errore',
    tryAgain: 'Riprova',
    statSet: 'Set',
    statTimer: 'Timer',
    statTarget: 'Target',
    pause: 'Pausa',
    resume: 'Riprendi',
    tracker: 'Tracker',
    skip: 'Salta',
    startFormCheck: 'Avvia Form Check',
    upNext: 'A seguire',
    restLabel: 'Riposo {value}',
    loading: 'Caricamento timer...',
    wakeLockUnavailable: 'Wake lock schermo non disponibile; il dispositivo potrebbe andare in stop durante il timer.',
    formCheckLimitReached: 'Limite giornaliero Form Check raggiunto.',
  },
  profileEditor: {
    saveTraining: 'Salva impostazioni allenamento',
    saveProfile: 'Salva solo profilo',
    saving: 'Salvataggio...',
    addCustomEquipment: 'Aggiungi attrezzatura personalizzata',
    add: 'Aggiungi',
    cancel: 'Annulla',
    optionalNotes: 'Note opzionali',
    allergiesCheckbox: 'Ho allergie',
    allergiesPlaceholder: 'Elenca allergie o reazioni.',
    validationWorkoutDays: 'Scegli esattamente {expected} giorn{suffix} di allenamento prima di salvare.',
    modeTraining: {
      title: 'Impostazioni Allenamento',
      description: 'Aggiorna solo familiarità con l\'esercizio, attività settimanale, sessioni a settimana e giorni preferiti per allenarti.',
      badgeLabel: 'Focus allenamento',
    },
    modeFull: {
      title: 'Modifica Profilo',
      description: 'Il salvataggio qui aggiorna il tuo profilo senza rigenerare automaticamente il tuo piano quest.',
      badgeLabel: 'Modalità modifica',
    },
    modeRequired: {
      title: 'Modifica Profilo',
      description: 'Il salvataggio qui aggiorna il tuo profilo senza rigenerare automaticamente il tuo piano quest.',
      badgeLabel: 'Profilo richiesto',
    },
  },
};
